import { render } from "./EligibilitySection.vue?vue&type=template&id=65053e94"
import script from "./EligibilitySection.vue?vue&type=script&lang=js"
export * from "./EligibilitySection.vue?vue&type=script&lang=js"

import "./EligibilitySection.vue?vue&type=style&index=0&id=65053e94&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__